<template>
  <div>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="card-body-form">
              <!-- 内容 -->
              <div>
                <div class="flex-align-center" style="margin-bottom: 10px">
                  <div style="font-weight: bold">置顶内容：</div>
                  <i
                    @click="refresh"
                    class="el-icon-refresh"
                    style="
                      font-size: 20px;
                      margin-left: 10px;
                      font-weight: bold;
                      color: #556ee6;
                      cursor: pointer;
                    "
                  ></i>
                </div>

                <div class="item">
                  <t-table
                    rowKey="id"
                    :columns="columns"
                    :data="top_list"
                    dragSort="row-handler"
                    :scroll="{ type: 'lazy', bufferSize: 10 }"
                    @drag-sort="onDragSort"
                    :loading="topLoading"
                    :max-height="640"
                  >
                    <!-- <template #status="{ row, }">
                      <p
                        class="status"
                        :class="['', 'warning', 'unhealth'][row.status]"
                      >
                        {{ ["健康", "警告", "异常"][row.status] }}
                      </p>
                    </template> -->
                    <!-- <template #attachment="{row}">
                      <div
                        v-if="row.attachmentDtoList && row.attachmentDtoList[0]"
                      >
                        <div v-if="row.attachmentDtoList[0].type == 'image'">
                          <img
                            :src="row.attachmentDtoList[0].url"
                            style="cursor:pointer;height:50px"
                            @click="showImg(row.attachmentDtoList[0].url)"
                          />
                        </div>
                      </div>
                      <span v-else>--</span>
                    </template> -->
                    <template #message="{ row }">
                      {{ row.message
                      }}<t-icon
                        color="#556ee6"
                        name="attach"
                        v-if="row.attachments && row.attachments[0]"
                      />
                    </template>
                    <template #state="{ row }">
                      <span v-if="row.state == 0">自己可见</span>
                      <span v-if="row.state == 1">全部可见</span>
                      <span v-if="row.state == 2">删除</span>
                      <!-- <el-tooltip
                        :content="row.state == 1 ? '点击隐藏' : '点击显示'"
                      >
                        <span
                          v-if="row.state == 1"
                          class="dsply-fix status-open"
                          @click="changeStatus(row)"
                          ><i></i>显示</span
                        >
                        <span
                          v-if="row.state == 0"
                          class="dsply-fix status-off"
                          @click="changeStatus(row)"
                          ><i></i>隐藏</span
                        >
                      </el-tooltip> -->
                    </template>
                    <template #verifyState="{ row }">
                      {{ showState(row.verifyState) }}
                    </template>
                    <template #drag="{ row, rowIndex }">
                      <el-button
                        size="mini"
                        type="primary"
                        @click="toDetail(row.relationId)"
                        v-if="power['编辑']"
                        >编辑</el-button
                      >
                      <el-button
                        size="mini"
                        type="primary"
                        @click="removeTop(row, rowIndex)"
                        v-if="power['置顶/取消置顶']"
                        >取消置顶</el-button
                      >
                      <el-button
                        size="mini"
                        type="primary"
                        @click="toReply(row)"
                        v-if="power['回复']"
                        >回复</el-button
                      >
                      <!-- <el-button
                        size="mini"
                        type="danger"
                        @click="deleteConfirm(row.id, rowIndex, 1)"
                        >删除</el-button
                      > -->

                      <i
                        style="font-size: 20px; margin-left: 10px"
                        class="el-icon-rank"
                      ></i>
                    </template>
                  </t-table>
                </div>
              </div>
              <!-- 列表 -->
              <div style="margin-top: 27px">
                <div style="margin-bottom: 13px">
                  <div style="display: flex; justify-content: space-between">
                    <span style="font-weight: bold">内容列表：</span>

                    <span style="display: flex">
                      <!-- <span>
                        <b-form-select
                          @change="getContentList"
                          v-model="pageParams.showState"
                          class="form-select"
                          :options="statusOptions"
                          style="width:100px;height:32px;margin-right:15px"
                          type="text"
                        ></b-form-select>
                      </span> -->
                      <el-input
                        style="width: 225px; margin-right: 20px"
                        v-model="pageParams.content"
                        size="mini"
                        placeholder="id、内容"
                        @keyup.enter.native="getContentList"
                      ></el-input>
                      <el-button
                        type="primary"
                        size="mini"
                        @click="getContentList"
                        >搜索</el-button
                      >
                      <el-button size="mini" @click="resetSearch"
                        >重置</el-button
                      >
                    </span>
                  </div>
                </div>
                <div class="item">
                  <t-table
                    rowKey="id"
                    :columns="columnsHT"
                    :data="content_list"
                    :loading="contentLoading"
                  >
                    <!-- <template #status="{ row }">
                      <p
                        class="status"
                        :class="['', 'warning', 'unhealth'][row.status]"
                      >
                        {{ ["健康", "警告", "异常"][row.status] }}
                      </p>
                    </template> -->
                    <!-- <template #attachment="{row}">
                      <div v-if="row.attachmentDtoList[0]">
                        <div v-if="row.attachmentDtoList[0].type == 'image'">
                          <img
                            :src="row.attachmentDtoList[0].url"
                            style="cursor:pointer;height:50px"
                            @click="showImg(row.attachmentDtoList[0].url)"
                          />
                        </div>
                      </div>
                      <span v-else>--</span>
                    </template> -->
                    <template #message="{ row }">
                      {{ row.message
                      }}<t-icon
                        color="#556ee6"
                        name="attach"
                        v-if="row.attachments && row.attachments[0]"
                      />
                    </template>
                    <!-- <template #state="{ row }">
                      <el-tooltip
                        :content="row.state == 1 ? '点击隐藏' : '点击显示'"
                      >
                        <span
                          @click="changeStatus(row)"
                          v-if="row.state == 1"
                          class="dsply-fix status-open"
                          ><i></i>显示</span
                        >
                        <span
                          v-if="row.state == 0"
                          class="dsply-fix status-off"
                          @click="changeStatus(row)"
                          ><i></i>隐藏</span
                        >
                      </el-tooltip>
                    </template> -->
                    <template #state="{ row }">
                      <span v-if="row.state == 0">自己可见</span>
                      <span v-if="row.state == 1">全部可见</span>
                      <span v-if="row.state == 2">删除</span>
                    </template>
                    <template #verifyState="{ row }">
                      {{ showState(row.verifyState) }}
                    </template>
                    <template #option="{ row, rowIndex }">
                      <el-button
                        size="mini"
                        type="primary"
                        @click="toDetail(row.relationId)"
                        v-if="power['编辑']"
                        >编辑</el-button
                      >
                      <el-button
                        size="mini"
                        type="primary"
                        @click="setTop(row, rowIndex)"
                        v-if="power['置顶/取消置顶']"
                        >置顶</el-button
                      >
                      <el-button
                        size="mini"
                        type="primary"
                        @click="toReply(row)"
                        v-if="power['回复']"
                        >回复</el-button
                      >
                      <!-- <el-button
                        size="mini"
                        type="danger"
                        @click="deleteConfirm(row.id, rowIndex, 2)"
                        >删除</el-button
                      > -->
                    </template>
                  </t-table>
                  <pagination
                    ref="page"
                    :pageSize="pageParams.pageSize"
                    :page="pageParams.page"
                    :pageSizes="[30, 50, 100]"
                    :total="pageTotal"
                    @pageCallback="pageCallback"
                  ></pagination>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 新建 -->

    <ContentDetail
      :id="contentId"
      v-if="detailModal"
      :visible.sync="detailModal"
    />
  </div>
</template>

<script>
import ContentDetail from "./contentDetail.vue";
import { contentList, contentTop } from "@/server/api/topic.js";
import groupApi from "@/server/api/group.js";
import { addCache, updateCache } from "@/util/localAche.js";
const columns = [
  { colKey: "id", title: "ID", width: 100 },
  {
    colKey: "nickName",
    title: "用户信息",
    width: 120,
  },
  {
    colKey: "message",
    title: "正文",
    width: 200,
    fixed: "left",
  },
  // { colKey: "attachment", title: "附件", width: 100 },
  { colKey: "verifyState", title: "审核状态", width: 120 },
  { colKey: "state", title: "状态", width: 100 },
  { colKey: "createdAt", title: "发布时间", width: 180 },

  {
    colKey: "drag", // 列拖拽排序必要参数
    title: "操作",
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    // cell: (h) => <i style="font-size:20px;" class="el-icon-rank"></i>,
    width: 260,
    fixed: "right",
  },
];
const columnsHT = [
  { colKey: "id", title: "ID", width: 100 },
  {
    colKey: "nickName",
    title: "用户信息",
    width: 120,
  },
  {
    colKey: "message",
    title: "正文",
    width: 200,
    fixed: "left",
  },
  // { colKey: "attachment", title: "附件", width: 100 },
  { colKey: "verifyState", title: "审核状态", width: 120 },
  { colKey: "state", title: "状态", width: 100 },
  { colKey: "createdAt", title: "发布时间", width: 180 },

  {
    colKey: "option", // 列拖拽排序必要参数
    title: "操作",
    width: 260,
    fixed: "right",
  },
];

export default {
  components: {
    ContentDetail,
  },
  data() {
    return {
      contentId: undefined,
      loading: false,
      total_list: [],
      pageTotal: 5,
      top_list: [],
      content_list: [],
      detailModal: false,
      columns,
      columnsHT,
      pageParams: {
        page: 1,
        pageSize: 30,
        // type: 2, // 0:草稿，1:初遍池，2：文章列表
        // showState: "", //0隐藏1显示
        // sortBy: "",
        // order: "",
        content: "",
        isTop: 0,
      },
      search: {
        keyword: "",
      },
      items: [],
      addDialog: false,
      titleFlag: "",
      tags: [],
      statusOptions: [
        { text: "筛选状态", value: "" },
        { text: "显示", value: 1 },
        { text: "隐藏", value: 0 },
      ],
      topLoading: false,
      contentLoading: false,
      mediaId: "",
      topicId: "", //话题ID
      userId: "", //题主ID
      power: [],
    };
  },
  beforeMount() {},
  created() {
    this.power = this.utils.currentPower("话题-内容管理");
    this.topicId = Number(this.$route.query.topicId);
    this.userId = this.$route.query.userId;
    this.pageParams.id = this.topicId;
    let obj = this.getCache("topic-content-list");
    if (obj) {
      if (obj.top_list && obj.top_list[0]) {
        this.top_list = obj.top_list;
      } else {
        this.getTopList(false);
      }
      if (obj.content_list && obj.content_list[0]) {
        this.content_list = obj.content_list;
        this.pageTotal = obj.pageTotal;
        this.pageParams = obj.pageParams;
      } else {
        this.getContentList(false);
      }
    } else {
      this.getData();
    }
  },
  beforeRouteEnter(to, from, next) {
    if (["/topicComment"].indexOf(from.path) == -1) {
      updateCache("topic-content-list", { top_list: "", content_list: "" });
      addCache("");
    }
    next();
  },
  beforeRouteLeave(to, from, next) {
    if (["/topicComment"].indexOf(to.path) == -1) {
      updateCache("topic-content-list", { top_list: "", content_list: "" });
      addCache("");
    } else {
      addCache("topic-content-list", {
        top_list: this.top_list,
        content_list: this.content_list,
        pageParams: this.pageParams,
        pageTotal: this.pageTotal,
      });
    }
    next();
  },
  methods: {
    changeStatus(item) {
      // let params;
      // if (Array.isArray(item)) {
      //   params = item;
      // } else {
      //   params = item;
      // }
      groupApi.contentStatus(item.id).then((res) => {
        console.log("更改结果", res);
        if (res.code === 0) {
          item.state = !item.state;
        } else {
          this.warning(res.msg);
          console.log(res);
        }
      });
    },
    // deleteContent(id, isTop, index) {
    //   let params = {};
    //   if (typeof id == "number") {
    //     let arr = [];
    //     arr.push(id);
    //     params.ids = arr;
    //   } else {
    //     params.ids = id;
    //   }
    //   groupApi.commentDelete(params).then((res) => {
    //     console.log("更改结果", res);
    //     if (isTop === undefined)
    //       if (res.code === 0) {
    //         if (isTop) {
    //           this.top_list.splice(index, 1);
    //         } else {
    //           let position =
    //             (this.pageParams.page - 1) * this.pageParams.pageSize + index;
    //           this.total_list.splice(position, 1);
    //         }
    //       }
    //   });
    // },
    resetSearch() {
      this.pageParams.showState = "";
      this.pageParams.content = "";
      this.pageParams.page = 1;
      this.getContentList();
    },
    showState(state) {
      if (state === 0) {
        return "草稿";
      } else if (state === 1) {
        return "通过";
      } else if (state === 2) {
        return "驳回";
      } else if (state == 3) {
        return "待审核";
      }
    },
    // currentData is going to be deprecated
    onDragSort({
      currentIndex,
      current,
      targetIndex,
      target,
      data,
      newData,
      e,
    }) {
      console.log(
        "交换行",
        currentIndex,
        current,
        targetIndex,
        target,
        data,
        newData,
        e
      );
      let oldList = this.another(this.top_list);
      this.top_list = newData;
      let params = [];
      this.top_list.forEach((item, index) => {
        let obj = {};
        obj.id = item.id;
        obj.isTop = 1;
        obj.sort = index;
        params.push(obj);
      });
      contentTop(params).then((res) => {
        if (res.code === 0) {
          this.$message.success("排序成功！");
        } else {
          this.top_list = oldList;
          this.warning(res.msg);
        }
      });
    },

    //给组件的回调
    pageCallback(obj) {
      if (obj.code === "pageSize") {
        this.pageParams.pageSize = obj.ps;
        this.getContentList();
      }
      if (obj.code === "page") {
        //更改页码
        this.pageParams.page = obj.page;
        this.getContentList();
      }
    },
    showImg(url) {
      this.ShowImg(url);
    },
    getData() {
      this.getTopList();
      this.getContentList();
    },
    openDetailModal() {
      this.detailModal = true;
    },
    getTopList() {
      this.topLoading = true;
      let params = {
        page: 1,
        pageSize: 100000,
        id: this.pageParams.id,
        isTop: 1,
      };
      console.log("置顶内容搜索参数", params);
      contentList(params).then((res) => {
        console.log("置顶列表", res);
        if (res.code === 0) {
          this.topLoading = false;
          if (res.data) {
            this.top_list = res.data.items;
            updateCache("topic-content-list", { top_list: res.data.items });
          } else {
            this.top_list = [];
          }
        }
      });
    },
    getContentList(showLoading) {
      if (showLoading !== false) {
        this.contentLoading = true;
      }
      let params = this.another(this.pageParams);
      this.cleanObj(params);
      console.log("内容列表搜索参数", params);
      contentList(params).then((res) => {
        console.log("内容列表", res);
        if (res.code === 0) {
          this.contentLoading = false;
          this.content_list = res.data.items;
          updateCache("topic-content-list", {
            content_list: res.data.items,
            pageTotal: res.data.total,
          });
          // this.changePage();
          this.pageTotal = res.data.total;
        }
      });
    },
    toDetail(id) {
      this.contentId = id;
      this.detailModal = true;
    },
    async saveTop() {
      let params = [];
      let list_now = [];
      this.top_list.forEach((item, index) => {
        let obj = {};
        obj.id = item.id;
        obj.isTop = 1;
        obj.sort = index;
        params.push(obj);
        list_now.push(item.id);
      });
      console.log("保存参数", params);
      contentTop(params).then((res) => {
        if (res.code === 0) {
          this.success("保存成功！");
          this.getData();
        } else {
          this.warning(res.msg);
        }
      });
    },
    setTop(item, index) {
      let arr = this.another(this.top_list);
      arr.unshift(item);
      let params = [];
      arr.forEach((item, index) => {
        let obj = {};
        obj.id = item.id;
        obj.isTop = 1;
        obj.sort = index;
        params.push(obj);
      });
      contentTop(params).then((res) => {
        if (res.code === 0) {
          this.$message.success("置顶成功！");
          // this.getData();
          this.content_list.splice(index, 1);
          this.top_list = arr;
          this.pageTotal -= 1;
        } else {
          this.warning(res.msg);
        }
      });
    },
    removeTop(item, index) {
      let params = [];
      params.push({
        id: item.id,
        isTop: 0,
      });
      contentTop(params).then((res) => {
        if (res.code === 0) {
          this.$message.success("取消置顶成功！");
          this.content_list.unshift(item);
          this.top_list.splice(index, 1);
          this.pageTotal += 1;
          this.getContentList(false);
        } else {
          this.warning(res.msg);
        }
      });

      // this.changePage();
    },
    // deleteItem(index) {
    //   let page = 10;
    //   let size = 10;
    //   let total_list = [];
    //   let list = [];
    //   let position = (page - 1) * size + index;
    //   let item = total_list[position]; //被删除的元素
    //   total_list.splice(position, 1);
    //   this.changePage();
    // },
    deleteContent(id, index, position) {
      let arr = [];
      arr.push(id);
      let params = { ids: arr };
      groupApi.commentDelete(params).then((res) => {
        console.log("删除结果", res);
        if (res.code === 0) {
          this.success("删除成功");
          if (position == 1) {
            this.top_list.splice(index, 1);
          } else {
            this.content_list.splice(index, 1);
          }
        } else {
          this.warning(res.msg);
          console.log(res);
        }
      });
    },
    deleteConfirm(id, index, position) {
      this.confirm("确认删除该条内容？", () => {
        this.deleteContent(id, index, position);
      });
    },
    toReply(item) {
      this.$router.push({
        path: "topicComment",
        query: {
          commentId: item.relationId,
          topicId: this.topicId,
          userId: this.userId,
        },
      });
    },
    goBack() {
      this.$router.go(-1);
    },
    refresh() {
      this.getTopList();
      this.getContentList();
    },
  },
};
</script>

<style lang="scss" scoped>
.tagWrap {
  .el-tag + .el-tag {
    margin-left: 10px;
  }
}

.tagWarp {
  margin-bottom: 13px;
  display: flex;
  .searTag {
    height: 350px;
    width: 70%;
  }
  .checkTag {
    height: 350px;
    width: 30%;
  }
}
.checkWarp {
  background: #ffffff;
  border: 1px solid #e2e2e2;
  border-radius: 3px;
  padding: 10px;
  height: 100%;
}
::v-deep th {
  padding: 8px 8px 7px 8px;
}
::v-deep td {
  padding: 8px 8px 7px 8px;
}
</style>
